import { useState } from "react";
import { Link } from "react-router-dom";

import logo from "../../../Assets/Logo/lipana.svg";
import google from "../../../Assets/Logo/google.svg";
import github from "../../../Assets/Logo/github.svg";
import email from "../../../Assets/Logo/email.svg";
import twitter from "../../../Assets/Logo/twitter.svg";
import phone from "../../../Assets/Logo/phone.svg";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { useSelector, useDispatch } from "react-redux";
import { mailLogin, phoneLogin } from "../../../Slices/SignSlice";

// Step 1: Sign Up Form
export const SignUpForm = ({ clickFunction }) => {
  const value = useSelector((state) => state.sign.value);
  const dispatch = useDispatch();

  const logins = [
    { image: google, type: "" },
    { image: email, type: "mail" },
    { image: phone, type: "phone" },
    { image: twitter, type: "" },
    { image: github, type: "" },
  ];

  const countryCodes = [
    { name: "Kenya", code: "+254", country: "ke", id: 1 },
    { name: "Ugandan", code: "+256", country: "ug", id: 2 },
    { name: "Tanzanian", code: "+255", country: "tz", id: 3 },
    { name: "Rwandan", code: "+257", country: "rw", id: 4 },
  ];

  const [query, setQuerry] = useState("ke");
  const [countryCode, setCountryCode] = useState("+254");
  const [select, setSelect] = useState(false);

  return (
    <div className="w-full bg-white flex flex-col items-center justify-center text-black space-y-8 md:w-[60%] lg:w-3/4">
      <Link to="/">
        <img src={logo} alt="" className="mx-auto" />
      </Link>
      <form
        action=""
        className="border rounded-[25px] relative mx-auto p-8 space-y-8 w-full lg:w-[40%] lg:max-w-[40%]"
      >
        <div className="text-blackColor">
          <h2 className="text-3xl font-semibold">Sign Up</h2>
          <p className="font-semibold">Create a free account</p>
        </div>
        {value === "number" ? (
          <div>
            <div className="flex flex-row rounded-lg overflow-hidden border pl-1">
              <div className="flex flex-row items-center gap-2 py-3 pl-2">
                <img
                  src={`https://flagcdn.com/w20/${query}.png`}
                  alt="flag"
                  className="h-6 w-6 object-contain"
                />
                <p
                  className="flex flex-row gap-1  pr-5  cursor-pointer md:pr-0"
                  onClick={() => setSelect(!select)}
                >
                  {countryCode.toUpperCase()}
                  {select ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </p>
              </div>
              <input
                className="pl-1 rounded-r-lg md:pl-0"
                type="number"
                required
              />
            </div>
            <div
              className={`${
                select ? `block` : `hidden`
              } absolute w-[83%] !mt-0 bg-[#f8f7f4] z-10 p-3 rounded-lg space-y-5 overflow-auto`}
            >
              {countryCodes.map((item, i) => (
                <div
                  key={i}
                  className="flex flex-row gap-2 cursor-pointer text-blackColor"
                  onClick={() => {
                    setQuerry(item.country);
                    setCountryCode(item.code);
                    setSelect(!select);
                  }}
                >
                  <img
                    src={`https://flagcdn.com/w20/${item.country}.png`}
                    alt="flag"
                    className="h-6 w-6 object-contain !rounded-lg"
                  />
                  <p className="text-gray-700">
                    {item.code} - {item.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div>
            <input
              type="text"
              placeholder="Enter your email"
              className="border w-full py-3 px-2 rounded-lg"
            />
          </div>
        )}
        <button
          onClick={() => clickFunction("code")}
          className="block border w-full p-3 bg-brandColor text-white font-semibold text-center rounded-full cursor-pointer"
        >
          Continue
        </button>
        <p className="relative text-center font-semibold divider">Or</p>
        <div className="flex flex-row justify-center gap-5">
          {logins.map((login, i) => (
            <div
              onClick={() =>
                login.type === "mail"
                  ? dispatch(mailLogin())
                  : login.type === "phone"
                  ? dispatch(phoneLogin())
                  : ""
              }
              className={`border w-max h-max rounded-full ${
                login.type === "phone" && value === "number"
                  ? `hidden`
                  : `block`
              } p-1 cursor-pointer ${
                login.type === "mail" && value === "mail" ? `hidden` : `block`
              }`}
              key={i}
            >
              <img src={login.image} alt="" className="h-7" />
            </div>
          ))}
        </div>
        <div className="flex flex-row items-center gap-1 justify-center text-sm">
          <p>Already have an account?</p>
          <Link to="/" className="text-brandColor">
            Log in.
          </Link>
        </div>
      </form>
    </div>
  );
};

// step 2: Confirmation code
export const CodeForm = ({ clickFunction }) => {
  const value = useSelector((state) => state.sign.value);
  return (
    <div className="flex flex-col justify-center md:w-3/4">
      <div className="shadow-[0px 4px 4px rgba(0, 0, 0, 0.1)] border rounded-[20px] mx-auto h-max text-blackColor w-full p-8 md:p-16 lg:w-1/2">
        <h2 className="text-2xl font-semibold md:text-4xl">
          Enter confirmation code
        </h2>
        <p className="mt-2 md:text-lg md:w-3/4">
          A 4-digit confirmation code was sent to your{" "}
          {`${value === "number" ? "number" : "email"}`} , please enter below
        </p>
        <div className="flex flex-row justify-center gap-5 w-full mt-8">
          <input
            type="text"
            className="h-10 w-10 border rounded-lg text-center"
          />
          <input
            type="text"
            className="h-10 w-10 border rounded-lg text-center"
          />
          <input
            type="text"
            className="h-10 w-10 border rounded-lg text-center"
          />
          <input
            type="text"
            className="h-10 w-10 border rounded-lg text-center"
          />
        </div>
        <button
          onClick={() => clickFunction("password")}
          className="block border w-full mx-auto my-8 p-3 bg-brandColor text-white font-semibold text-center rounded-full cursor-pointer md:w-3/4"
        >
          CONFIRM
        </button>
        <p className="text-brandColor text-center text-base font-semibold">
          Resend code in : 00:59
        </p>
      </div>
    </div>
  );
};

// step 3: Create Password
export const PasswordForm = ({ clickFunction }) => {
  const [userPassword, setPassword] = useState("");

  function checkPasswordStrength(password) {
    var lowerCaseRegex = /[a-z]/g;
    var upperCaseRegex = /[A-Z]/g;
    var numberRegex = /[0-9]/g;
    var specialCharRegex = /[\W_]/g;

    var lowerCaseScore = 5;
    var upperCaseScore = 5;
    var numberScore = 5;
    var specialCharScore = 5;

    // Calculate the password strength score
    var strengthScore = 0;
    if (password.match(lowerCaseRegex)) {
      strengthScore += lowerCaseScore;
    }
    if (password.match(upperCaseRegex)) {
      strengthScore += upperCaseScore;
    }
    if (password.match(numberRegex)) {
      strengthScore += numberScore;
    }
    if (password.match(specialCharRegex)) {
      strengthScore += specialCharScore;
    }

    if (strengthScore === 0) {
      return 0;
    } else if (strengthScore < 8) {
      return 5;
    } else if (strengthScore < 16) {
      return 10;
    } else {
      return 20;
    }
  }

  const [type, setType] = useState("password");

  return (
    <div className="flex flex-col justify-center md:w-3/4">
      <div className="shadow-[0px 4px 4px rgba(0, 0, 0, 0.1)] border rounded-[20px] mx-auto h-max text-blackColor w-full p-8 md:p-16 lg:w-1/2">
        <h2 className="text-2xl font-semibold text-center md:text-4xl">
          Create a password
        </h2>
        <p className="text-lg mb-5 mt-3 text-center md:w-[80%] mx-auto">
          Please choose a safe and secure password. You will use this to access
          your dashboard.
        </p>
        <div>
          <div className="flex flex-row items-center border px-2 rounded-lg md:w-[80%] md:mx-auto">
            <input
              onChange={(e) => setPassword(e.target.value)}
              type={type}
              placeholder="Enter Password"
              className="w-[90%] py-2 md:py-3"
            />
            <div className="w-[5%]">
              {type === "password" ? (
                <VisibilityOffIcon onClick={() => setType("text")} />
              ) : (
                <RemoveRedEyeIcon onClick={() => setType("password")} />
              )}
            </div>
          </div>
          <div className="grid grid-cols-4 mt-3 gap-5 md:w-[80%] mx-auto">
            <p
              className={`${
                checkPasswordStrength(userPassword) === 0
                  ? `bg-red-600`
                  : `bg-green-300`
              } py-1 px-5 rounded-full`}
            ></p>
            <p
              className={`${
                checkPasswordStrength(userPassword) >= 5
                  ? `bg-green-300`
                  : `bg-red-600`
              } py-1 px-5 rounded-full`}
            ></p>
            <p
              className={`${
                checkPasswordStrength(userPassword) >= 10
                  ? `bg-green-300`
                  : `bg-red-600`
              } py-1 px-5 rounded-full`}
            ></p>
            <p
              className={`${
                checkPasswordStrength(userPassword) >= 20
                  ? `bg-green-300`
                  : `bg-red-600`
              } py-1 px-5 rounded-full`}
            ></p>
          </div>
        </div>
        <button
          onClick={() => clickFunction("info")}
          className="block border w-full mx-auto mt-8 p-3 bg-brandColor text-white font-semibold text-center rounded-full cursor-pointer md:w-3/4"
        >
          CONTINUE
        </button>
      </div>
    </div>
  );
};

// step 4: Set Up Info
export const InfoForm = () => {
  return (
    <div className="flex flex-col justify-center md:w-3/4">
      <div className="shadow-[0px 4px 4px rgba(0, 0, 0, 0.1)] border rounded-[20px] mx-auto h-max text-blackColor p-8  md:p-16 lg:w-1/2">
        <h2 className="text-2xl font-semibold mb-5 md:text-4xl">
          Tell us more about you
        </h2>
        <div className="mx-auto space-y-5 md:w-[90%]">
          <div className="flex flex-row gap-5">
            <input
              type="text"
              placeholder="First Name"
              className="w-1/2 px-2 py-2.5 border rounded-lg"
            />
            <input
              type="text"
              placeholder="Last Name"
              className="w-1/2 px-2 py-2.5 border rounded-lg"
            />
          </div>
          <input
            type="text"
            placeholder="Email"
            className="w-full px-2 py-2.5 border rounded-lg"
          />
          <input
            type="text"
            placeholder="Invite code (optional)"
            className="w-full px-2 py-2.5 border rounded-lg"
          />
          <div className="flex flex-row items-start gap-2">
            <input type="checkbox" className="mt-1" />
            <p>
              Please choose a safe and secure password. You will use this to
              access your dashboard.
            </p>
          </div>
        </div>
        <button className="block border w-full mx-auto mt-8 p-3 bg-brandColor text-white font-semibold text-center rounded-full cursor-pointer md:w-[90%]">
          CREATE ACCOUNT
        </button>
      </div>
    </div>
  );
};
